<template>
    <li
        class="app-select__dropdown-li"
        :class="elementClasses"
        :value="value"
        @click="select"
        @keydown="onKeydown"
    >
        {{ value.title }}
    </li>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'AppSelectElement',
    props: {
        value: {
            type: Object,
            required: true
        },
        selected: {
            type: Object,
            required: true
        },
        isFirstIndex: {
            type: Boolean,
            required: true
        },
        isLastIndex: {
            type: Boolean,
            required: true
        },
        onElementSelect: {
            type: Function,
            required: true
        },
        onClose: {
            type: Function,
            required: true
        }
    },
    computed: {
        isActive() {
            return this.selected.id === this.value.id
        },
        elementClasses() {
            return { 'app-select__dropdown-li_type_active': this.isActive }
        },
        ...mapState({
            isGlobalControlLocked: state => state.keyControl.isGlobalControlLocked
        })
    },
    methods: {
        select() {
            this.onElementSelect(this.value)
        },
        onKeydown(event) {
            if (this.isGlobalControlLocked) return
            switch (event.code) {
                case 'Tab': {
                    if (this.isLastIndex && !event.shiftKey
                        || this.isFirstIndex && event.shiftKey
                    ) {
                        event.preventDefault()
                    }
                    break
                }
                case 'Escape': {
                    this.onClose()
                    break
                }
                case 'Space':
                case 'Enter': {
                    this.select()
                    break
                }
            }
        }
    }
}
</script>